import { WarehouseDetailPage } from "@/features/warehouse/pages/WarehouseDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/warehouse/$id/detail")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["warehouse.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: WarehouseDetailPage,
});
